<div class="truck-registration-summary">
  <sc-title>
    <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.title"></sc-dictionary-label>
  </sc-title>

  @if (isUsingSmartphone) {
    <p>
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.description"></sc-dictionary-label>
    </p>
  }

  <mat-card>
    <table>
      <tr>
        <td class="label"><label>
          <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.numberPlate"></sc-dictionary-label>:</label></td>
          <td class="bold">{{numberPlate}}</td>
        </tr>
        <tr>
          <td class="label"><label><sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.driver"></sc-dictionary-label>:</label></td>
          <td class="bold">{{driver}}</td>
        </tr>
        <tr>
          <td class="label"><label><sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.label.carrier"></sc-dictionary-label>:</label></td>
          <td class="bold">{{carrier}}</td>
        </tr>
      </table>
    </mat-card>

    <div class="success">
      <i class="fa-light fa-sharp fa-check-circle"></i>
    </div>

    @if (gatekeeperMandatory) {
      <p class="gatekeeper-hint">
        <sc-dictionary-label dictionaryKey="tmc-yard.widgets.registration-terminal.transport-registration-summary.hint"></sc-dictionary-label>
      </p>
    }
  </div>
